<template>
  <div class="magazine-page christmas-app-no-overlay">

    <MagazineDetails
      title="British Beef Sirloin Joint"
      image="christmas-highlight-1.jpg"
      :isVisible="this.isVisible"
      @toggled="toggleActive"
    /> 
    <TheHeader></TheHeader>
    <BreadcrumbBar />
    <section class="magazine-notification-banner">We can’t wait for you to explore our Christmas 2023 range. Thank you - and Merry Christmas from the team at Morrisons</section>
    <PageHeroChristmas imagedesktop="christmas-hero-2023-desktop.jpg" imagemobile="christmas-hero-2023-mobile.jpg" data-aos="fade-in">
      <!-- <TextHeading variant="subtitle">Christmas 2023</TextHeading>
      <TextHeading variant="xl"
        >Lorem ipsum dolor sit amet, consectetur adipiscing elit.</TextHeading
      > -->
    </PageHeroChristmas>
    <PageGrid>
      <PageMain>
        <PageSection>
          <MagazineMainText data-aos="fade-in" data-aos-offset="200" />
        </PageSection>
        <section class="magazine-filter__wrapper"> <TheFilterMagazine /></section>
         
      <section class="magazine-page-section__christmas">
        <section class="magazine-page-section__christmas-highlight">
          <MagazineHighlights
            @click.native="toggleActive"
            data-aos="fade-in"
  
          />
          <!-- <div class="flex-1 border"></div> -->
        </section>
        <!-- <PageHero
          transparent
          image="christmas-hero-v2.jpg"
          data-aos="fade-in"
          data-aos-offset="200"
        /> -->
        <!-- <MagazineFeature @click.native="toggleActive" title="Christmas Title" /> -->
        <PageSection>
          <MagazineGallery @click.native="toggleActive" />
        </PageSection>
      </section>
        <!-- <PageSection title="The Main Event">
          <MagazineCarousel data-aos="fade-in" data-aos-offset="200" />
        </PageSection> -->
        
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import PageGrid from '../elements/PageGrid.vue'
import PageHeroChristmas from '../components/PageHeroChristmas.vue'
import TheFooter from '../components/TheFooter.vue'
// import TextHeading from '../elements/TextHeading.vue'
// import MagazineSection from '../elements/MagazineSection.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
import TheFilterMagazine from '../components/TheFilterMagazine.vue'
import MagazineMainText from '../components/MagazineMainText.vue'
import MagazineHighlights from '../components/MagazineHighlights.vue'
// import MagazineFeature from '../components/MagazineFeature.vue'
import MagazineGallery from '../components/MagazineGallery.vue'
// import MagazineCarousel from '../components/MagazineCarousel.vue'
import MagazineDetails from '../components/MagazineDetails.vue'

export default {
  name: 'ChristmasHome',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageMain,
    PageSection,
    // MagazineSection,
    TheFooter,
    // TextHeading,
    PageHeroChristmas,
    PageGrid,
    TheFilterMagazine,
    MagazineMainText,
    MagazineHighlights,
    // MagazineFeature,
    MagazineGallery,
    // MagazineCarousel,
    MagazineDetails,
  },
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    toggleActive() {
      this.isVisible = !this.isVisible
    },
    handleClick(url) {
      window.location.href = url
    },
  },
}
</script>

<style lang="postcss">
html {
@apply w-full;
overflow-x: hidden;
}
.christmas-app-no-overlay .magazine-details__info .prose {
  @apply mb-4;
}
.hide-carousel {
  display: none!important;
}
.christmas-header {
  position: relative!important;
}
.christmas-filter {
  @apply sticky top-0;
  z-index: 90!important;
  background-color:#f7f4ed!important;
  box-shadow:  0 4px 6px -2px rgba(0, 0, 0, .25);
}
#app.christmas-app-no-overlay {
overflow-x: visible !important;
}
.magazine-notification-banner {
  background-color:#A81815;
  @apply text-white text-center leading-tight text-sm py-2 px-4 ;
}
.magazine-page {
  background-color:#F6F4ED;
}
.magazine-filter__wrapper {
  @apply flex justify-center w-full pb-0 ;
}
.magazine-page-section__christmas {
  @apply w-full flex flex-col max-w-screen-2xl mx-auto;
}
.magazine-page-section__christmas .page-section {
  @apply mt-0;
}
@screen md {
  .magazine-notification-banner {
  @apply text-base;
}
.magazine-page-section__christmas {
  @apply w-full flex flex-row flex-no-wrap py-4;
}
.magazine-page-section__christmas .page-section { 
  @apply flex-1;
}
.magazine-page-section__christmas-highlight { 
  @apply flex-1 flex flex-col pl-4;
  /* @apply flex-1 flex flex-col ml-6 mr-2; */
} 
}
@screen lg {
  .magazine-page-section__christmas-highlight {
    @apply  pl-6 pr-2;
  }
}

/* @screen 2xl {
  .magazine-page-section__christmas-highlight { 
    @apply ml-6;
  border:1px red dashed;
} 
} */
</style>
